// extracted by extract-css-chunks-webpack-plugin
module.exports = {"why":"why___F_JAY","why-header":"why-header___1VVgU","reasons":"reasons___1ANAl","reason":"reason___ClO9L"};